import { useTranslation } from "react-i18next";

export default function AppDownload() {
    const { t } = useTranslation();
    return (
        <section className="newsletter__area">
            <div className="container">
                <div className="row align-items-center g-md-4 g-lg-5 g-sm-2">
                <div className="col-md-7">
                    <div className="colToActionArea position-relative z-3">
                    <div className="title">
                        <h2 className="text-white">
                        {t('appDownload.available_on_android_ios')}
                        </h2>
                    </div>
                    <div className="app-download">
                        <a href="#">
                        <img
                            className="rounded img-fluid"
                            src="assets/img/google-play.svg"
                            alt={t('appDownload.image_alt')}
                        />
                        </a>
                        <a href="#">
                        <img
                            className="rounded img-fluid"
                            src="assets/img/apple-store.svg"
                            alt={t('appDownload.image_alt')}
                        />
                        </a>
                    </div>
                    </div>
                </div>
                <div className="col-md-5">
                    <div className="newsletter__img-wrap z-3">
                    <img src="assets/img/newsletter_img.png" className="img-fluid" alt={t('appDownload.image_alt')} />
                    </div>
                </div>
                </div>
            </div>
            </section>

    )
}